import searchIcon from "@tabler/icons/outline/search.svg";
import React from "react";
import { defineMessages, useIntl } from "react-intl";

import Account from "../account";
import { Icon } from "../ui";

import type { Account as AccountEntity } from "@/schemas";

const messages = defineMessages({
  action: { id: "search.action", defaultMessage: "Search for “{query}”" },
});

interface SearchResultRowProps {
  account: AccountEntity;
}

export function SearchResultRow({ account }: SearchResultRowProps) {
  return (
    <Account
      account={account}
      hideActions
      showProfileHoverCard={false}
      withLinkToProfile={false}
    />
  );
}

interface SearchFooterRowProps {
  query: string;
}

export function SearchFooterRow({ query }: SearchFooterRowProps) {
  const intl = useIntl();

  return (
    <div className="flex min-w-0 flex-1 items-center space-x-2">
      <Icon src={searchIcon} className="size-4" />
      <span className="overflow-hidden text-ellipsis">
        {intl.formatMessage(messages.action, { query })}
      </span>
    </div>
  );
}
